import {Maybe} from "@martin_hotell/rex-tils";

export function wrapperOfClickOutside<R>(ref: Maybe<HTMLElement>, event, fn: () => void) {
    if (ref &&
        !ref.contains(event.target)) {
        fn();
    }

}
